/* eslint-disable import/no-default-export */
import CoachmarkTooltip from './components/CoachmarkTooltip.tsx';

export default CoachmarkTooltip;
